import { api } from '../services/api'
import type { Persona } from './personas'

export type AskPersonaId = Persona['id']

const CHAT_IDENTITY: Record<AskPersonaId, { id: string; name: string }> = {
  archie: { id: 'agent-001', name: 'Archie (Arquiteto de Soluções)' },
  dochie: { id: 'agent-002', name: 'Dochie (Analista Multidimensional)' },
  jobs: { id: 'agent-003', name: 'Jobs (Event Storming)' },
  vangogh: { id: 'agent-004', name: 'Van Gogh (Visualizador de Arquitetura)' },
}

export const ASK_FALLBACK: Record<AskPersonaId, string> = {
  archie: 'O ponto que mais pede decisão é o limite entre o que o sistema garante e o que fica com o time.',
  dochie: 'Olhando o canvas: falta uma ideia sobre limites — o que o sistema recusa, o que ele adia e quem aprova a exceção.',
  jobs: 'No fluxo, o evento que ainda não está nomeado é o momento em que a regra muda de dono. Vale um hotspot aí.',
  vangogh: 'O diagrama que falta é o que mostra quem fala com quem nesse passo. Um fluxo curto já esclarece.',
}

export function chatIdentity(persona: AskPersonaId) {
  return CHAT_IDENTITY[persona]
}

export function personaFromMention(text: string): AskPersonaId | null {
  const lower = text.toLowerCase()
  if (!lower.includes('@')) return null
  if (lower.includes('@van')) return 'vangogh'
  if (lower.includes('@archie')) return 'archie'
  if (lower.includes('@dochie')) return 'dochie'
  if (lower.includes('@jobs')) return 'jobs'
  return null
}

export async function askPersona(persona: AskPersonaId, message: string, context: string): Promise<string> {
  const res = await api.post('/api/v1/agent/ask', { persona, message, context })
  const reply = String(res.data?.reply || '').trim()
  return reply || ASK_FALLBACK[persona]
}
